import axios from 'axios'

export const API_BASE_URL = `${process.env.REACT_APP_API_URL}`

const instance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    accept: 'application/json',
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
   // mode: 'no-cors',
    'X-YT-DEVELOPMENT': 'local'
  }
})

export default instance

// instance.interceptors.response.use(
//   response => (response),
//   error => (Promise.reject(error.response.data.err))
// )

